import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Use the current origin so the API call works on any host the app is served from
// (Emergent preview, .emergent.host production, or the custom domain).
// Falls back to REACT_APP_BACKEND_URL when not running in a browser (SSR/tests).
const BACKEND_URL =
  (typeof window !== 'undefined' && window.location.origin) ||
  process.env.REACT_APP_BACKEND_URL;

export const API_BASE = `${BACKEND_URL}/api`;

export const demoUsers = {
  apprentice: {
    role: 'apprentice',
    name: 'John Murphy',
    email: 'john.murphy@demo.ie'
  },
  employer: {
    role: 'employer',
    name: 'Sarah O\'Brien',
    email: 'hiring@celtictech.ie'
  },
  admin: {
    role: 'admin',
    name: 'Admin User',
    email: 'admin@apprentimatch.ie'
  }
};
